import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PAGE_TEXT } from '../../../constants/system-pages.constants'; // adjust path to where you keep it
import { clearSystemPageAccess } from '../../../../guard/navigation-flag.guard';

@Component({
  selector: 'app-memberlogout',
  imports: [CommonModule],
  templateUrl: './memberlogout.html',
  styleUrl: './memberlogout.scss',
})
export class Memberlogout {
  appName = 'CES Mail Merge';
  protected readonly text = PAGE_TEXT.memberLogout; 

  constructor(private router: Router) {}

  signInAgain(): void {
    this.router.navigate(['/']);
  }

}